export default __webpack_public_path__ + "static/media/cloudIcon.09637a96.png";